import { render, staticRenderFns } from "./ColorPickerSwatches.vue?vue&type=template&id=8945df94&scoped=true"
import script from "./ColorPickerSwatches.vue?vue&type=script&lang=js"
export * from "./ColorPickerSwatches.vue?vue&type=script&lang=js"
import style0 from "./ColorPickerSwatches.vue?vue&type=style&index=0&id=8945df94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8945df94",
  null
  
)

export default component.exports